'use strict';

module.exports = (app) => app.factory('demandService', /* @ngInject */ function (apiConfig, httpService) {

	/**
	 * Create a new demand from an existing rfq
	 * @param rfqId {number}
	 * @param fromRfqItems {boolean}
	 * @returns {Promise<void>}
	 */
	function copyFromRfq(rfqId, fromRfqItems) {
		const url = apiConfig.getBase('demand', 'create', 'from-rfq');
		const data = {
			rfqId,
			fromRfqItems
		};
		return httpService.post(url.toString(), data);
	}

	/**
	 * Create a new demand from basket with given id
	 * @param basketId {number}
	 * @returns {Promise<void>}
	 */
	function copyFromBasket(basketId) {
		const url = apiConfig.getBase('demand', 'create', 'from-basket');
		const data = {
			basketId
		};
		return httpService.post(url.toString(), data);
	}

	return {
		copyFromRfq,
		copyFromBasket
	}

});
